import Image from 'next/image';
import { useRouter } from 'next/router';

import { IBookShop } from '@/utils/interfaces/BooksShop';

interface BookCardProps {
  book: IBookShop;
  bookCount?: number;
  courseCount?: number;
}

const CoursesCard = ({ book }: BookCardProps) => {
  const router = useRouter();

  const formattedPrice = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(book.price);

  const formattedOriginalPrice = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(book.originalPrice);
  return (
    <div
      onClick={() => {
        router.push(`/courses/${book.slug}/?id=${book.id}`);
      }}
      className='w-full h-full md:border-cartBgColor md:border  hover:bg-[#151515] card rounded-[12px] cursor-pointer flex flex-col transition duration-300'
    >
      <div className='h-full  card rounded-md text-fadedWhite'>
        <div className='flex flex-col justify-between items-center h-full w-full  '>
          <div className='md:p-6'>
            <div className='relative w-[200px] xxxs:w-[160px] md:w-[228px] lgXL:w-[258px] aspect-[16/9] flex justify-center'>
              <Image
                src={book?.coverImage}
                alt={book?.title}
                fill
                className='object-contain rounded-md'
              />
            </div>
          </div>

          <div className='flex items-end flex-col p-4 lg:p-6 w-full'>
            <div className='w-full flex flex-col justify-center gap-y-1 py-4 md:py-0 items-center'>
              <div className='text-center text-[10px] md:text-xs text-primary font-medium tracking-wider  uppercase '>
                {book.category}
              </div>
              <span className='text-sm md:text-lg font-semibold text-center line-clamp-1'>
                {book?.title}
              </span>

              <div className='flex items-center justify-center gap-2'>
                <span className='text-lg font-semibold'>{formattedPrice}</span>
                <span className='text-[#9F9EA6] line-through font-medium text-sm'>
                  {formattedOriginalPrice}
                </span>
                <span className='text-[#4ADE80] font-medium text-sm'>
                  {book.discount}%
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoursesCard;
